module.exports = __webpack_public_path__ + "media/images/icons/double-quote-serif-left-81fe1f953bd9c76f78859f20becefb2d.svg";